import { createContext, ReactNode } from 'react';
import { TokenLimitOrderEntryResponse } from 'services/Deso';

interface TradeContextValue {
  selectedTokenOrderBook: TokenLimitOrderEntryResponse[];
  transactorOrders: TokenLimitOrderEntryResponse[];
}

export const TradeContext = createContext<TradeContextValue>({
  selectedTokenOrderBook: [],
  transactorOrders: [],
});

interface TradeContextProviderProps {
  selectedTokenOrderBook: TokenLimitOrderEntryResponse[];
  transactorOrders: TokenLimitOrderEntryResponse[];
  children: ReactNode;
}

export const TradeContextProvider = ({
  selectedTokenOrderBook,
  transactorOrders,
  children,
}: TradeContextProviderProps) => {
  const tradeContextValue: TradeContextValue = {
    selectedTokenOrderBook,
    transactorOrders,
  };

  return <TradeContext.Provider value={tradeContextValue}>{children}</TradeContext.Provider>;
};
